<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.43479 31.0651L6.43914 31.0651L9.41089 27.0651L21.0847 27.0651L15.9347 44.5651L19.7957 44.5651L30.0957 27.0651L41.5848 27.0651C42.4167 27.0651 43.1214 26.7764 43.6989 26.1988C44.2765 25.6213 44.5652 24.9166 44.5652 24.0847C44.5652 23.2528 44.2765 22.5481 43.6989 21.9705C43.1214 21.393 42.4167 21.1042 41.5848 21.1042L30.0957 21.1042L19.7957 3.60422L15.9347 3.60422L21.0847 21.1042L9.41089 21.1042L6.43914 17.1042L3.43475 17.1042L5.3978 24.0847L3.43479 31.0651Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
